import { FieldSets } from '../models/utilities/form.model';
import { Prospect } from '../models/entities/prospect.model';

export default class UserDataPrefillService {
  static parseMMeUser(
    owUser: any,
    ciamId: string | null,
    {
      fieldSets,
      aemForms,
    }: {
      fieldSets: FieldSets;
      aemForms: any;
    }
  ): Prospect {
    const prospect: Prospect = {
      ciamId,
    };
    const aemFormsEnable: boolean = aemForms?.enabled;

    fieldSets &&
      Object.keys(fieldSets).forEach((setKey) => {
        const { fields } = fieldSets[setKey];
        prospect[setKey] = {};
        fields &&
          Object.keys(fields!).forEach((fieldKey) => {
            const { mercedesMeMapping, type } = fields![fieldKey];
            const isDropdown = type === 'dropdown';
            const isCheckbox = type === 'checkbox';
            if (!isCheckbox && owUser) {
              prospect[setKey][fieldKey] = UserDataPrefillService.getValue(
                owUser[fieldKey],
                isDropdown,
                aemFormsEnable
              );
              // override default with mapping
              if (mercedesMeMapping) {
                prospect[setKey][fieldKey] = UserDataPrefillService.getValue(
                  owUser[mercedesMeMapping],
                  isDropdown,
                  aemFormsEnable
                );
              }
            }
          });
      });
    return prospect;
  }

  static getValue(
    value: any,
    isDropdown: boolean,
    aemFormsEnable: boolean
  ): any {
    return isDropdown && !aemFormsEnable ? value?.toLowerCase() : value;
  }
}
